import config from '../utils/config';

// A tutorial section or step tied to a feature still behind a build flag must
// stay out of sight where that feature does not render.
const tutorialFeatureEnabled = (featureFlag) => ((!featureFlag) || Boolean(config[featureFlag]));

export default tutorialFeatureEnabled;
